export const HomeLinkRoutes = {
  home: 'home',
  tempPermission: '/tempPermission',
  deviceTempPermission: '/deviceTempPermission',
  login: '/login',
  devices: '/devices',
  groups: '/groups',
  users: '/users',
  notifications: '/notifications',
  calendar: '/calendar',
  hours: '/hours',
  hydro: '/hydro',
  accountManager: '/account-manager',
  mamoleo: '/mamoleo',
  management: '/management',
  messageMember: '/messageMember',
  bulkNotification: '/bulkNotification',
};
